export const NoResultsItemMessages = {
  paragraph: {
    id: 'Pages.ConsumerAddress.Auto.noResultsFound',
    description: 'Could not find the address above'
  }
}
